import { render, staticRenderFns } from "./otherOpt.vue?vue&type=template&id=0c72396a&scoped=true&"
import script from "./otherOpt.vue?vue&type=script&lang=js&"
export * from "./otherOpt.vue?vue&type=script&lang=js&"
import style0 from "./otherOpt.vue?vue&type=style&index=0&id=0c72396a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72396a",
  null
  
)

export default component.exports